import React from 'react';
import styles from './TopTitle.module.scss';
import SquareIcon
  from 'gui/components/listPage/components/ad/components/squareIcon';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';
import {When} from 'react-if';

interface ITopTitleProps {
  title: string | any;
  subTitleDetail: string | any;
  subTitleElement?: any;
  icon: any;
  toolTip: string;
  iconStyle: any;
  loading?: boolean;

  iconContainerClassName?: string;
}

const TopTitle = props => {
  const icon = props.loading ? null : props.icon;
  return <>
    <SquareIcon
      icon={icon}
      iconElement={
        props.loading
        &&
        <SkeletonPlaceHolder
          width={25}
          height={25}
          style={{
            backgroundColor: "#05BEC0"
          }}
        />}
      toolTip={props.toolTip ? props.toolTip : props.title}
      iconContainerClassName={`${props.loading ? styles.squareIconLoading : `${styles.squareIcon} ${props.iconContainerClassName}`}`}
      iconClassName={styles.squareIcon}
      style={{
        ...props.iconStyle
      }}
    />
    <When condition={!!props.title || !!props.loading}>{() =>
      <h4 className={`${styles.topRow} ${icon ? styles.topRowIcon : ''}`}>
        {props.loading ? <SkeletonPlaceHolder
          variant="text"
          width={200}
          style={{marginRight: 50}}
        /> : props.title}
      </h4>}
    </When>
    <When condition={!!props.subTitleDetail}>
      {() => <h6 className={styles.subTitleDetail}>
        {props.subTitleDetail}
      </h6>}
    </When>
    {props.subTitleElement}
  </>;
}

TopTitle.defaultProps = {};

export default React.memo(TopTitle);
